import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import MainContent from './mainContent';
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';

const LoadComment = Loadable({
    loader: () => import('ThreeTerminal_pc/comment/comment'),
    loading() {
        return <div />;
    },
});

class LeftContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { article },
        } = this.props;
        const {
            noAd,
            allowComment,
            title,
            summery,
            imagesInContent,
            pcUrl,
            url,
            commentUrl,
            skey,
            contentData,
            editorName,
            editorCode,
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
        } = article;
        const pluginData = {
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
        };

        const shareInfo = {
            url: commentUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        const commentConfig = {
            noAd,
            // 文章单页的页面地址
            docUrl: commentUrl,
            // 文章的标题
            docTitle: title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl,
            // 获取评论内容接口
            cmtNumUrl: '//comment.ifeng.com/get.php',
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: '//comment.ifeng.com/post.php',
            // 最热评论数量
            hotLimit: 2,
            // 评论区域的高度限制
            limitHeight: '',
            // 推荐评论接口
            cmtVoteUrl: '//comment.ifeng.com/vote.php',
            // 现实回复的楼层
            replyLimit: 5,
            // 举报提交接口
            jubUrl: '//comment.ifeng.com/report',
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
            // 是否允许评论
            allowComment,
        };

        return (
            <div className={styles.leftContent}>
                <div className={styles.artical}>
                    <MainContent
                        shareInfo={shareInfo}
                        content={contentData}
                        pluginData={pluginData}
                        editorName={editorName}
                        editorCode={editorCode}
                    />
                    <div className="clear" />
                    <LazyLoad>
                        <LoadComment articleInfo={commentConfig} />
                    </LazyLoad>
                </div>
            </div>
        );
    }
}

export default errorBoundary(LeftContent);
